import { formatMoney } from 'helpers/number';
import ApplicationController from '../application_controller';

export default class extends ApplicationController {
  static targets = ['selectable', 'selectionCount', 'submitBtn', 'totalCharge', 'totalSelectionCount'];

  selectedServices = [];

  connect() {
    this.totalSelectionCountTarget.innerText = this.selectableTargets.length.toString();
  }

  disconnect() {
    this.selectedServices = [];
  }

  /**
   * @event Dispatched by `superbill--section:select`
   */
  selectService(event) {
    const service = this.selectedServices.find(({ id }) => id === event.detail.id);
    if (service) return;

    this.selectedServices.push(event.detail);
    this.updateUI();
  }

  /**
   * @event Dispatched by `superbill--section:deselect`
   */
  deselectService(event) {
    const index = this.selectedServices.findIndex(({ id }) => id === event.detail.id);
    if (index === -1) return;

    this.selectedServices.splice(index, 1);
    this.updateUI();
  }

  // Private

  updateUI() {
    this.toggleBtnDisability();
    this.updateTotalCharge();
    this.selectionCountTarget.innerText = this.selectedServices.length.toString();
  }

  toggleBtnDisability() {
    this.submitBtnTarget.disabled = this.selectedServices.length === 0;
  }

  updateTotalCharge() {
    this.totalChargeTarget.innerText = formatMoney(this.totalCharge);
  }

  get totalCharge() {
    return this.selectedServices.reduce((acc, service) => acc + service.charge, 0);
  }
}
